// Central English -> Spanish translation for saga SHOW_ALERT titles/messages.
// The strings are formulaic ("<verb phrase> <entity>"), so translation is done
// by prefix rules (verb phrase) + an entity map (trailing noun) + a few exact
// overrides. Anything already in Spanish or unmapped falls through unchanged.

// Exact-match overrides (checked first). Also lists already-Spanish strings only
// when a cleaner wording is wanted; otherwise Spanish strings just fall through.
const EXACT = {
  Error: "Error",
  "Failed Load Data": "Error al cargar los datos",
  "Failed to load": "Error al cargar",
  "Load failed": "Error al cargar",
  "Update failed": "Error al actualizar",
  "Create failed": "Error al crear",
  "Upload Failed": "Error al subir",
  "Error downloading CSV": "Error al descargar el CSV",
  "Failed pdf": "Error al generar el PDF",
  "Loading Alerts": "Cargando alertas",
  "Failed fetch receivings": "Error al obtener las recepciones",
  "The file has the errors, but the download failed.":
    "El archivo tiene errores, pero la descarga falló.",
  "Failed login": "Error al iniciar sesión",
  "Invalid username or password": "Usuario o contraseña inválidos",
  "Session expired": "Sesión expirada",
  "Your session has expired. Please log in again.":
    "Tu sesión expiró. Por favor, iniciá sesión de nuevo.",
  "Error reading the guides": "Error al leer las guías",
  "Certificate downloading failed": "Error al descargar el certificado",
  "Failed Timeline": "Error al cargar la línea de tiempo",
  "Process adjustment approval failed": "Error al aprobar el ajuste",
  "Successfull change state": "Estado cambiado correctamente",
  "Successful order locked": "Orden bloqueada correctamente",
  "Successful orders locked": "Órdenes bloqueadas correctamente",
  "Successful order lock deleted": "Bloqueo de orden eliminado correctamente",
};

// Verb-phrase prefixes. Longest keys are tried first (sorted below), so
// "Successful delete soft" wins over "Successful delete".
const PREFIX_RULES = {
  "Successful delete soft": "Eliminado correctamente",
  "Failed delete soft": "Error al eliminar",
  "Successful change operator": "Operador cambiado correctamente",
  "Failed change operator": "Error al cambiar el operador",
  "Successful change state": "Estado cambiado correctamente",
  "Failed change state": "Error al cambiar el estado",
  "Successful upload file": "Archivo subido correctamente",
  "Failed upload file": "Error al subir el archivo",
  "Successful address confirm": "Dirección confirmada correctamente",
  "Failed address confirm": "Error al confirmar la dirección",
  "Failed download general report": "Error al descargar el reporte general",
  "Failed download inventory report": "Error al descargar el reporte de inventario",
  "Successful upload": "Subido correctamente",
  "Failed upload": "Error al subir",
  "Successful reverse": "Reversado correctamente",
  "Failed reverse": "Error al reversar",
  "Successful save": "Guardado correctamente",
  "Failed save": "Error al guardar",
  "Successful update": "Actualizado correctamente",
  "Failed update": "Error al actualizar",
  "Successful disable": "Deshabilitado correctamente",
  "Failed disable": "Error al deshabilitar",
  "Successful enable": "Habilitado correctamente",
  "Failed enable": "Error al habilitar",
  "Successful delete": "Eliminado correctamente",
  "Failed delete": "Error al eliminar",
  "Successful change": "Cambiado correctamente",
  "Failed change": "Error al cambiar",
  "Failed download": "Error al descargar",
  "Successful download": "Descargado correctamente",
  "Failed load": "Error al cargar",
};

// Trailing entity nouns (whole word, case-insensitive). Applied to the text that
// follows a translated verb phrase so "Error al cargar Addresses" -> "... direcciones".
const ENTITY_MAP = [
  ["Addresses Available", "direcciones disponibles"],
  ["Address Cardinal Point", "punto cardinal de dirección"],
  ["Companies by operator", "empresas por operador"],
  ["orders by user", "órdenes por usuario"],
  ["Coverage Types", "tipos de cobertura"],
  ["sub categories", "subcategorías"],
  ["Current Route", "ruta actual"],
  ["recordsreports", "reportes de novedades"],
  ["confirm report", "reporte de confirmación"],
  ["general report", "reporte general"],
  ["Addresses", "direcciones"],
  ["Address", "dirección"],
  ["Countries", "países"],
  ["Country", "país"],
  ["Companies", "empresas"],
  ["Company", "empresa"],
  ["Cities", "ciudades"],
  ["City", "ciudad"],
  ["Users", "usuarios"],
  ["User", "usuario"],
  ["Orders", "órdenes"],
  ["Order", "orden"],
  ["Routes", "rutas"],
  ["Route", "ruta"],
  ["Warehouses", "bodegas"],
  ["Warehouse", "bodega"],
  ["Origins", "orígenes"],
  ["Branches", "sucursales"],
  ["branches", "sucursales"],
  ["Novelties", "novedades"],
  ["novelties", "novedades"],
  ["rescheduling", "reprogramación"],
  ["reschedule", "reprogramación"],
  ["adjustment", "ajuste"],
  ["inventory", "inventario"],
  ["warehouse", "bodega"],
  ["order", "orden"],
  ["Note", "nota"],
  ["PDF", "PDF"],
];

const sortedPrefixes = Object.keys(PREFIX_RULES).sort((a, b) => b.length - a.length);

function translateEntities(text) {
  let out = text;
  ENTITY_MAP.forEach(([en, es]) => {
    out = out.replace(new RegExp(`\\b${en}\\b`, "gi"), es);
  });
  return out;
}

export function translateMessage(text) {
  if (typeof text !== "string" || !text.trim()) return text;
  const key = text.trim();
  if (EXACT[key]) return EXACT[key];
  for (const prefix of sortedPrefixes) {
    if (key.startsWith(prefix)) {
      const rest = key.slice(prefix.length);
      return (PREFIX_RULES[prefix] + translateEntities(rest)).replace(/\s+$/, "");
    }
  }
  return text; // already Spanish or unmapped -> leave unchanged
}
